import { DashboardOrAnalysisFiltersPreviewTitle } from '@modules/analysis/components/DashboardAndAnalysisFiltersPreview/DashboardOrAnalysisFiltersPreviewTitle';
import { WhereClausePreview } from '@modules/common/components/WhereClausePreview';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { getCombinedQuantifyAndDashboardFilters } from '@modules/quantify/utils';
import { Box, Button, alpha } from '@mui/material';

interface CombinedQuantifyFilterFieldProps {
  isReadOnly?: boolean;
  onRemove: () => void;
}

export const CombinedDashboardFilterField = ({
  isReadOnly,
  onRemove,
}: CombinedQuantifyFilterFieldProps) => {
  const dashboardFilters = useQuantifyStore(
    ({ visual }) => visual.dashboardFilters,
  );
  const query = useQuantifyStore(({ query }) => query);
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);

  const onRemoveDashboardFilter = () => {
    if (dashboardFilters) {
      const updatedDashboardFilters = {
        ...dashboardFilters,
        whereClause: undefined,
      };

      dispatch({
        type: QuantifyActionType.SET_VISUAL,
        payload: {
          dashboardFilters: updatedDashboardFilters,
          quantifyAndDashboardFilters: getCombinedQuantifyAndDashboardFilters({
            primaryQuery: query,
            dashboardFilters: updatedDashboardFilters,
          }),
        },
      });
    }
    onRemove();
  };

  return (
    <>
      <WhereClausePreview
        whereClause={dashboardFilters?.whereClause}
        valueTextColor={'info.main'}
        headerNode={
          !isReadOnly && (
            <DashboardOrAnalysisFiltersPreviewTitle
              isDashboardVariant
              secondaryAction={
                <Button
                  variant="text"
                  size="small"
                  color="info"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveDashboardFilter();
                  }}
                >
                  Remove
                </Button>
              }
            />
          )
        }
        sxProps={{
          backgroundColor: (theme) =>
            theme.palette.misc.queryBuilder.dashboardFilter.bgColor,
          borderBottom: 'none',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderColor: (theme) => alpha(theme.palette.info.main, 0.5),
          pb: 1,
          py: 0,
        }}
      />
      {/* Add space for the AND operator */}
      <Box
        sx={{
          height: '10px',
          width: '100%',
          backgroundColor: (theme) =>
            theme.palette.misc.queryBuilder.dashboardFilter.bgColor,
          border: '1px solid',
          borderColor: (theme) => alpha(theme.palette.info.main, 0.5),
          borderTop: 'none',
          borderBottom: 'none',
        }}
      />
    </>
  );
};
